module.exports = __webpack_public_path__ + "img/address-foreign-tablet.581cb614.svg";